/**
 * leadIntelligenceApi — Conversation Intelligence (Fase 3B).
 *
 * Capa derivada de solo-lectura sobre la conversación WhatsApp: el GET
 * devuelve el snapshot cacheado (+ stale); el POST genera/actualiza el
 * análisis de forma EXPLÍCITA (única vía que gasta una llamada IA — con
 * fingerprint idéntico el backend devuelve el cache sin coste).
 */
import { api } from "./api";

export async function getLeadIntelligence(leadId) {
  const { data } = await api.get(`/leads/${leadId}/conversation-intelligence`);
  return data;
}

export async function generateLeadIntelligence(leadId, { force = false } = {}) {
  const { data } = await api.post(
    `/leads/${leadId}/conversation-intelligence${force ? "?force=true" : ""}`
  );
  return data;
}
